import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Box, Select } from "@chakra-ui/react";
import MessageBody from "./MessageBody";
import RedirectWordpressBody from "./RedirectWordpressBody";
import RedirectExternalBody from "./RedirectExternalBody";
import { setConfigType } from "../../../../redux/actions/formConfigActions";
const Body = ({ configType, dispatchSetConfigType }) => {
  const handleOnChange = (e) => {
    e.preventDefault();
    const value = e.target.value;
    dispatchSetConfigType(value);
  };

  const renderBody = () => {
    switch (configType) {
      case "CONFIRMATION_MESSAGE":
        return <MessageBody />;
      case "REDIRECT_WORDPRESS_PAGE":
        return <RedirectWordpressBody />;
      case "REDIRECT_EXTERNAL_PAGE":
        return <RedirectExternalBody />;
    }
  };
  return (
    <Box mt="16px">
      <Box w="598px" h="32px">
        <select
          value={configType}
          onChange={handleOnChange}
          style={{
            minWidth: "598px",
            height: "32px",
            border: "1px",
            borderStyle: "solid",
            borderColor: "#CFD7DF",
            borderRadius: "4px",
            color: "#12344D",
            fontWeight: "600",
            fontSize: "14px",
          }}
        >
          <option value="CONFIRMATION_MESSAGE">Confirmation message</option>
          <option value="REDIRECT_WORDPRESS_PAGE">
            Redirect to a Wordpress page
          </option>
          <option value="REDIRECT_EXTERNAL_PAGE">
            Redirect to an external page
          </option>
        </select>
      </Box>
      {/* Edit Section */}
      {renderBody()}
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    configType: state.formConfig.configType,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatchSetConfigType: bindActionCreators(setConfigType, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Body);
